<template>

  <b-overlay
    :show="showOverlay"
    rounded="sm"
  >

    <commission-plan-add-new
      :is-add-new-commission-plan-sidebar-active.sync="isAddNewCommissionPlanSidebarActive"
      @refetch-data="refetchCommissionPlansData"
    />

    <template>

      <b-row>

        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >

          <template>

            <!-- Table Container Card -->
            <b-card
              no-body
            >

              <div class="m-2">
                <!-- Table Top -->
                <b-row>
                  <!-- Per Page -->
                  <b-col
                    cols="12"
                    md="6"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                  >
                    <label>Entries</label>
                    <v-select
                      v-model="perPage"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="perPageOptions"
                      :clearable="false"
                      class="per-page-selector d-inline-block ml-50 mr-1"
                    />
                  </b-col>
                  <!-- Add -->
                  <b-col
                    class="d-flex align-items-center justify-content-end"
                    cols="12"
                    md="6"
                  >
                    <b-button
                      v-if="$can('create', 'commission-plan')"
                      variant="primary"
                      @click="isAddNewCommissionPlanSidebarActive = true"
                    >
                      Toevoegen
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <b-table
                ref="refCommissionPlansListTable"
                :items="fetchCommissionPlans"
                responsive
                :fields="tableColumns"
                primary-key="id"
                :sort-by.sync="sortBy"
                :sort-desc.sync="isSortDirDesc"
                show-empty
                empty-text="Geen overeenkomende records gevonden"
                class="position-relative categorie-table"
              >

                <!-- Column: Id -->
                <template #cell(id)="data">
                  <b-link
                    :to="{ name: 'app-commission-plan-edit', params: { id: data.item.id }}"
                    class="font-weight-bold"
                  >
                    #{{ data.value }}
                  </b-link>
                </template>

                <!-- Column: Actions -->
                <template #cell(actions)="data">

                  <div class="text-nowrap">
                    <b-link
                      :id="`commission-plan-view-action-row-${data.item.id}`"
                      :to="{ name: 'app-commission-plan-edit', params: { id: data.item.id }}"
                    >
                      <feather-icon
                        :id="`commission-plan-row-${data.item.id}-preview-icon`"
                        class="cursor-pointer mx-1"
                        icon="EyeIcon"
                        size="16"
                      />
                    </b-link>
                    <b-tooltip
                      :target="`commission-plan-view-action-row-${data.item.id}`"
                      placement="top"
                    >
                      <p class="mb-0">
                        Aanpassen
                      </p>
                    </b-tooltip>
                    <feather-icon
                      :id="`commission-plan-row-${data.item.id}-delete-icon`"
                      class="cursor-pointer"
                      size="16"
                      icon="TrashIcon"
                      @click="confirmCommisionPlanDeleteText(data.item.id)"
                    />
                    <b-tooltip
                      :target="`commission-plan-row-${data.item.id}-delete-icon`"
                      placement="top"
                    >
                      <p class="mb-0">
                        Verwijderen
                      </p>
                    </b-tooltip>
                  </div>
                </template>

              </b-table>
            </b-card>

          </template>

        </b-col>

      </b-row>

    </template>

  </b-overlay>

</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BTable,
  BLink, BTooltip, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { onUnmounted, ref } from '@vue/composition-api'
import CommissionPlanAddNew from '@/views/pages/commission-plan/commission-plan-add/CommissionPlanAddNew.vue'
import commissionPlanStoreModule from '@/views/pages/commission-plan/commissionPlanStoreModule'
import useCommissionPlansList from '@/views/pages/commission-plan/useCommissionPlanList'

export default {
  components: {
    CommissionPlanAddNew,
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BLink,
    vSelect,
    BTooltip,
    BOverlay,
  },
  methods: {
    confirmCommisionPlanDeleteText(id) {
      this.$swal({
        title: 'Weet je het zeker?',
        text: 'U kunt dit niet meer terugdraaien!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, verwijder het!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          store.dispatch('app-commission-plan/deleteCommissionPlan', { id })
            .then(() => {
              this.refetchCommissionPlansData()
              this.$swal({
                icon: 'success',
                title: 'Verwijderd!',
                text: 'De locatie is verwijderd.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
        }
      })
    },
  },
  setup() {
    const COMMISSION_PLAN_APP_STORE_MODULE_NAME = 'app-commission-plan'

    // Register module
    if (!store.hasModule(COMMISSION_PLAN_APP_STORE_MODULE_NAME)) store.registerModule(COMMISSION_PLAN_APP_STORE_MODULE_NAME, commissionPlanStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(COMMISSION_PLAN_APP_STORE_MODULE_NAME)) store.unregisterModule(COMMISSION_PLAN_APP_STORE_MODULE_NAME)
    })

    const isAddNewCommissionPlanSidebarActive = ref(false)

    const {
      fetchCommissionPlans,
      tableColumns,
      perPage,
      currentPage,
      totalCommissionPlans,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refCommissionPlansListTable,
      refetchCommissionPlansData,
      showOverlay,
    } = useCommissionPlansList()

    return {
      fetchCommissionPlans,
      tableColumns,
      perPage,
      currentPage,
      totalCommissionPlans,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refCommissionPlansListTable,
      refetchCommissionPlansData,
      showOverlay,
      isAddNewCommissionPlanSidebarActive,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }

  .categorie-table{
    .description{
      width:30%;
    }
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
